module.exports = __webpack_public_path__ + "static/media/menu.2f081b8e.svg";